export default __webpack_public_path__ + "static/media/contact-banner-min.fb51458f.png";